var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-modal-close"},[_c('ModalContent',{attrs:{"close":_vm.close,"closeCheckout":_vm.closeCheckout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }